import { http } from './http.service';
import { RequestForm } from '@/types/request';
class RequestService {
  submitRequestForm = async (requestFormParams: RequestForm) => {
    const params = { ...requestFormParams, emailAccount: 'sabrina.chen@thermofisher.com' };
    const response = await http.post(`api/support/sendEmail`, params);
    return response;
  };
}

export const requestService = new RequestService();
